var _style, _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefits4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "69px",
    height: "69px",
    viewBox: "0 0 69 69",
    style: {
      enableBackground: "new 0 0 69 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill: #fff;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 69,
    height: 69
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.9,29.5c-3.1,0-5.8-1.8-7-4.6c-1.2-2.9-0.6-6,1.6-8.2l2.9-2.9l-7.1-7.1l-2.9,2.9c-2.2,2.2-5.3,2.8-8.2,1.6 c-2.9-1.2-4.6-3.8-4.6-7V0H29.5v4.1c0,3.1-1.8,5.8-4.6,7c-2.9,1.2-6,0.6-8.2-1.6l-2.9-2.9l-7.1,7.1l2.9,2.9 c2.2,2.2,2.8,5.3,1.6,8.2c-1.2,2.9-3.8,4.6-7,4.6H0v10.1h4.1c3.1,0,5.8,1.8,7,4.6c1.2,2.9,0.6,6-1.6,8.2l-2.9,2.9l7.1,7.1l2.9-2.9 c2.2-2.2,5.3-2.8,8.2-1.6c2.9,1.2,4.6,3.8,4.6,7V69h10.1v-4.1c0-3.1,1.8-5.8,4.6-7c2.9-1.2,6-0.6,8.2,1.6l2.9,2.9l7.1-7.1l-2.9-2.9 c-2.2-2.2-2.8-5.3-1.6-8.2c1.2-2.9,3.8-4.6,7-4.6H69V29.5H64.9z M34.5,53C24.3,53,16,44.7,16,34.5S24.3,16,34.5,16 C44.7,16,53,24.3,53,34.5S44.7,53,34.5,53 M34.5,19.4c-8.4,0-15.1,6.8-15.1,15.1c0,8.3,6.8,15.1,15.1,15.1 c8.3,0,15.1-6.8,15.1-15.1C49.6,26.1,42.8,19.4,34.5,19.4 M42.4,31.4l-8.6,8.4c0,0.1-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1 c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1 L26.6,35c-0.7-0.6-0.7-1.7,0-2.4c0.7-0.7,1.7-0.7,2.4,0l3.7,3.7l7.4-7.3c0.7-0.6,1.7-0.6,2.4,0C43.1,29.6,43.1,30.7,42.4,31.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits4);
export default __webpack_public_path__ + "static/media/Benefits4.b1b6a3ccbd0ff784621f82b76dbc2435.svg";
export { ForwardRef as ReactComponent };